import { useEffect, useState, KeyboardEvent } from "react";
import axios from "axios";

export default function Settings() {
  const userData = JSON.parse(localStorage.getItem("user"));
  const [formData, setFormData] = useState({
    email: "admin123@gmail.com",
  });
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // const handleKeyDown = (e) => {
  //   if (e.key === 'Enter' && inputValue.trim()) {
  //     e.preventDefault()
  //     setTags([...tags, inputValue.trim()])
  //     setInputValue('')
  //   }
  // }

  // const removeTag = (tagToRemove) => {
  //   setTags(tags.filter(tag => tag !== tagToRemove))
  // }

  useEffect(() => {
    console.log("User Data:", userData);
  }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

  const fetchTags = async () => {
    try {
      const response = await axios.get(
        "http://localhost:5000/api/message/getAllMessages"
      );
      setTags(response.data.messages);
      setError("");
    } catch (err) {
      setError("Failed to fetch tags");
      console.error("Error fetching tags:", err);
    } finally {
      setLoading(false);
    }
  };

  // Add a new message
//   const addMessage = async (message) => {
//     try {
//       const response = await axios.post(
//         "http://localhost:5000/api/message/addMessage",
//         { message: message },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       setTags((prevTags) => [...prevTags, response.data.message]); // Add the new message to the tags
//     } catch (error) {
//       console.error("Error adding message:", error);
//     }
//   };

//   const removeTag = async (tagId) => {
//     setLoading(true);
//     try {
//       await axios.delete(
//        `https://webai-forex-backend-ashy.vercel.app/api/notice/${tagId}`
//       );
//       setTags(tags.filter((tag) => tag._id !== tagId));
//       setError("");
//     } catch (err) {
//       setError("Failed to delete tag");
//       console.error("Error deleting tag:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

const removeTag = async (tagId) => {
    setLoading(true);
    try {
      await axios.delete(
        `http://localhost:5000/api/message/deleteMessage/${tagId}`
      );
      setTags(tags.filter((tag) => tag._id !== tagId));
      setError("");
    } catch (err) {
      setError("Failed to delete tag");
      console.error("Error deleting tag:", err);
    } finally {
      setLoading(false);
    }
  };
  

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault();
      setLoading(true);
      try {
        const response = await axios.post(
          "http://localhost:5000/api/message/addMessage",
          {
            message: inputValue.trim(),
          }
        );
        setTags([...tags, response.data.message]);
        setInputValue("");
        setError("");
      } catch (err) {
        setError("Failed to add tag");
        console.error("Error adding tag:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTags();
  }, [inputValue]);

  return (
    <>
      <div
        className="min-h-[91vh] relative pt-1"
        style={{ backgroundImage: "url(bg.svg)" }}
      >
        <div className="p-4 md:p-6 mt-20 md:mt-0">
          <h1 className="text-2xl font-bold mb-4">Settings</h1>
          <form className="space-y-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm md:text-[19.03px] leading-[1.2] text-[#8A8A8A] font-medium mb-2"
                >
                  Enter pre writtern messages
                </label>
                <div className="w-full outline-none border bg-white border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      padding: "8px",
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    {tags.map((tag) => (
                      <span
                        key={tag._id}
                        style={{
                          backgroundColor: "#3b82f6",
                          color: "white",
                          padding: "5px 10px",
                          borderRadius: "16px",
                          fontSize: "16px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {tag.message}
                        <button
                          type="button"
                          onClick={() => removeTag(tag._id)}
                          style={{
                            marginLeft: "4px",
                            background: "none",
                            border: "none",
                            color: "white",
                            cursor: "pointer",
                            fontSize: "16px",
                            fontWeight: "bold",
                          }}
                        >
                          ×
                        </button>
                      </span>
                    ))}
                    <input
                      type="text"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      onKeyDown={handleKeyDown}
                      style={{
                        flex: "1",
                        border: "none",
                        outline: "none",
                        fontSize: "14px",
                        minWidth: "120px",
                        backgroundColor: "transparent",
                      }}
                      placeholder="Type and press Enter..."
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}